import styled from "styled-components";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import { usePrivacy } from "../../../contexts/PrivacyContext";
import { FiBarChart2 } from 'react-icons/fi';

const GroupCard = ({ groupIndex, course, groups }) => {
    const navigate = useNavigate();
    const { setGroupInfo, setIsView, setCourseInfo } = useAuth();
    const { maskGroupName } = usePrivacy();

    const handleNavigateToDetail = async () => {
        try {
            const groupInfo = {
                groupId: groups[groupIndex].id,
                name: course.name,
                startDate: course.startDate,
                endDate: course?.endDate || null,
            };

            setCourseInfo({ courseId: course.id });
            setGroupInfo(groupInfo);
            setIsView(true);
            navigate(`/admin_activities`, { state: { groupIndex, groups } });
        } catch (error) {
            console.error("Error fetching course info:", error);
            const groupInfo = {
                groupId: groups[groupIndex].id,
                name: course.name,
                startDate: course.startDate,
                endDate: null,
            };
            setCourseInfo({ courseId: course.id });
            setGroupInfo(groupInfo);
            setIsView(true);
            navigate(`/admin_activities`, { state: { groupIndex, groups } });
        }
    };

    const handleNavigateToTeamDynamics = async (event) => {
        event.stopPropagation();
        
        try {
            const groupInfo = {
                groupId: groups[groupIndex].id,
                name: course.name,
                startDate: course.startDate,
                endDate: course.endDate || null,
            };

            setCourseInfo({ courseId: course.id });
            setGroupInfo(groupInfo);
            setIsView(true);
            
            const preloadedData = {
                groupIndex,
                groups,
                allEvents: groups[groupIndex].allEvents || [],
            };
            
            navigate(`/admin_team_dynamics`, { state: preloadedData });
        } catch (error) {
            console.error("Error fetching course info:", error);
            const groupInfo = {
                groupId: groups[groupIndex].id,
                name: course.name,
                startDate: course.startDate,
                endDate: null,
            };
            setCourseInfo({ courseId: course.id });
            setGroupInfo(groupInfo);
            setIsView(true);
            
            const preloadedData = {
                groupIndex,
                groups,
                allEvents: groups[groupIndex].allEvents || [],
            };
            
            navigate(`/admin_team_dynamics`, { state: preloadedData });
        }
    };

    // useEffect(() => {
    //     const fetchEventCount = async (groupId) => {
    //         const numLastTwoDayEvent = await eventCountLastTwoDay(groupId);
    //         const eventIds = await getAllEventIds(groupId);
    //         const numEvent = Object.keys(eventIds).length;
    //         setNumLastTwoDayEvent(numLastTwoDayEvent);
    //         setNumEvent(numEvent);
    //     };
    //     fetchEventCount(groups[groupIndex].id);
    // }, [groups[groupIndex].id]);

    return (
        <CardContainer onClick={handleNavigateToDetail}>
            <GroupTitle>{maskGroupName(groups[groupIndex].groupName) || "Group Name"}</GroupTitle>
            <GroupDetails>
                <DetailLine str="Last Two Day Events" num={groups[groupIndex].numLastTwoDayEvent} />
                <DetailLine str="Total Events" num={groups[groupIndex].numEvent} />
            </GroupDetails>
            <StatsButton 
                onClick={handleNavigateToTeamDynamics}
                title="View Team Dynamics"
            >
                <FiBarChart2 />
            </StatsButton>
        </CardContainer>
    );
};

const CardContainer = styled.div`
    background-color: white;
    border-radius: 10px;
    padding: 20px;
    width: 100%;
    height: 150px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: transform 0.2s;
    position: relative;
    &:hover {
        transform: scale(1.05);
    }
`;

const GroupTitle = styled.h4`
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
`;

const GroupDetails = styled.div`
    color: gray;
    font-size: 13px;
    margin-top: 8px;
    width: 100%;
`;

const DetailLine = ({ str, num }) => (
    <DetailLineContainer>
        <DetailText>{str}</DetailText>
        <DetailNum>{num}</DetailNum>
    </DetailLineContainer>
);

const DetailLineContainer = styled.div`
    display: flex;
    //justify-content: space-between;
    width: 100%;
    margin: 4px 0;
`;

const DetailText = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    width: 80%;
    text-align: left;
`;

const DetailNum = styled.span`
    //text-align: right;
    min-width: 30px;
`;

const StatsButton = styled.button`
    position: absolute;
    bottom: 10px;
    right: 10px;
    background-color: #9333ea;
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;
    
    &:hover {
        background-color: #5f4da3;
    }
    
    svg {
        width: 16px;
        height: 16px;
    }
`;

export default GroupCard;
